module.exports = __webpack_public_path__ + "923322382bed3c7aaf8737303aa7c3d2.svg";